import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative bg-white pt-16 pb-24 lg:pt-24 lg:pb-32" data-id="element-149">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-151">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-152">
            <h1 className="text-4xl lg:text-5xl font-bold text-[#1E293B] leading-tight mb-6" data-id="element-153">
              French Bulldog Smart Feeding System
            </h1>

            <p className="text-lg text-[#475569] mb-6 leading-relaxed" data-id="element-154">
              A simple 7-day feeding plan made specifically for sensitive
              Frenchies who need more consistency and calm at mealtime.
            </p>

            <p className="text-xl font-semibold text-[#0F766E] mb-8" data-id="element-155">
              Only $17 – Instant Digital Access
            </p>

            <div className="flex flex-col gap-3 mb-8" data-id="element-156">
              <Button size="lg" onClick={() => window.open('https://zensturia.com/cart/51508367163709:1', '_blank')} data-id="element-157">
                Get Instant Access Now
              </Button>
              <p className="text-sm text-[#94A3B8] font-medium text-center sm:text-left" data-id="element-158">
                Secure checkout · One-time payment · Instant download
              </p>
            </div>

            {/* Social proof */}
            <div className="flex items-center gap-3 pt-6 border-t border-[#E2E8F0]" data-id="element-159">
              <div className="flex items-center" data-id="element-160">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-161" />)}
              </div>
              <span className="text-sm font-medium text-[#475569]" data-id="element-162">
                500+ Frenchie owners are already using this system
              </span>
            </div>
          </motion.div>

          {/* Image/Product Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex justify-center lg:justify-end" data-id="element-163">
            <div className="bg-white rounded-xl shadow-md border border-[#E2E8F0] p-6 max-w-md w-full" data-id="element-164">
              <div className="aspect-[4/5] rounded-lg overflow-hidden bg-[#F8FAFC]" data-id="element-165">
                <img src="https://cdn.magicpatterns.com/uploads/cxuG8NR2ydA8RjHSBWWLXo/ChatGPT_Image_Mar_2,_2026,_08_05_55_PM.png" alt="French Bulldog Smart Feeding System Guide" loading="lazy" decoding="async" className="w-full h-full object-cover object-center" data-id="element-166" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}